import { Button, Form, Input, Modal } from 'antd'
import Context from 'context/appContext';
import { useEffect } from 'react';
import { useContext } from 'react';
import { useState } from 'react'
import { getUrl, getValueField, validateForm } from 'utils/utils';
import CardImg from '../../../assets/images/beneficiario-preferente.png'
import CardImgFact from '../../../assets/images/datos-facturacion.png'
import SelectField from '../select';
import TextField from '../text';
import EliminarImg from '../../../assets/images/trash.svg';

// @styles 
import './styles.scss'

export default function CardEdit({ info, key, form, current }) {
    const { customRequest, dataForm: { formResponses }, typePerson, formStatus: { steps, currentStep, currentQuestion } } = useContext(Context);
    const [minClass, setMinClass] = useState('max');
    const [showCard, setShowCard] = useState(false);
    const [keys, setKeys] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [copyComponent, setCopyComponent] = useState({});

    const keysItem = {
        razonSocialPreferente: true,
        regimenFiscalContratante: true,
        cpFacturacion: true
    };

    useEffect(() => {
        const indexPanel = formResponses.findIndex(x => x.key === info.key);
        if (indexPanel !== -1) {
            const active = formResponses[indexPanel] && formResponses[indexPanel].active;
            setShowCard(active);
            setMinClass(active ? 'min' : 'max');
        } else {
            formResponses.push(info)
        }

    }, [])

    useEffect(()=>{
        setActive();
    },[showCard])


    useEffect(() => {
        if (Object.keys( typePerson).length > 0 && info.key === 'panelContratante' && showCard) {
            deleteCard(false);
        }
    }, [typePerson])

    useEffect(() => {
        let fieldsValue = {};
        const fields = info && info.components && info.components.map(field => field.input === true && field.key).filter(x => x);
        setKeys(fields);
        fields && fields.forEach(x => {
            fieldsValue[x] = getValueField(x, formResponses);
        })
        setCopyComponent(fieldsValue);
    }, [info])

    const saveCopyComponent = (info) => {
        let fieldsValue = {};
        const components = info.components.filter((field) => keysItem[field.key]);
        if (components && components.length) {
            components.forEach((component) => {
                const value = form.getFieldValue(component.key);
                const index = formResponses.findIndex((x) => x.key === component.key);
                component.value = value;
                index !== -1 ? formResponses[index] = component : formResponses.push(component);
                fieldsValue[component.key] = value;
            });
        }
        setCopyComponent(fieldsValue);
    }

    const setActive = () => {
        const indexPanel = formResponses.findIndex(x => x.key === info.key);
        if (indexPanel !== -1) {
            formResponses[indexPanel]['active'] = showCard;
        } else {
            info['active'] = showCard;
            formResponses.push(info);
        }
    }

    const saveClass = async () => {
        if (await validateForm(keys, form)) {
            saveCopyComponent(info);
            setMinClass('min');
        }
    }

    const showModal = (response) => {
        const message = response.renderMessage ? response.renderMessage :
            response.message && { renderMessage: { title: "Error", body: response.message } };
        if (response && message) {
            Modal.info({
                icon: '',
                title: message.renderMessage.title,
                className: 'modal-confirm',
                closable: true,
                okButtonProps: {
                    className: 'ant-btn-solid c-2 ant-btn-size-xs'
                },
                okText: 'Aceptar',
                content: <p>{message.renderMessage.body}</p>,
                onOk() { }
            });
        }
    }

    const onClick = () => {
        setShowCard(!showCard);
    }

    const editClass = () => {
        setIsEdit(true);
        setFieldsValue();
        setMinClass('max');

    }

    const setFieldsValue = () => {
        copyComponent && Object.keys(copyComponent) && Object.keys(copyComponent).length > 0 && Object.keys(copyComponent).forEach(x => {
            form.setFieldsValue({ [x]: copyComponent[x] });
        })

    }

    const deleteCard = (modal) => {
        if (modal) {
            configModal(info && info.properties && info.properties.delete ? info.properties.delete : '¿Estás seguro de eliminar tu Beneficiario Preferente?',
                'Aceptar',
                'Confirmación')
        } else {
            setCopyComponent({});
            setIsEdit(false);
            setActive();
            setShowCard(!showCard);

            keys.forEach(key => {
                setFieldsValue(key, '', null, formResponses, form);
                const index = formResponses.findIndex(x => x.key === key);
                if (index !== -1) {
                    formResponses[index].value = '';
                }
            })
            form.resetFields(keys);
            setMinClass('max');
        }
    }

    const cancelCard = () => {
        if (isEdit) {
            const components = info.components.filter((field) => keysItem[field.key]);
            if (components && components.length) {
                components.forEach((component) => {
                    const value = copyComponent[component.key];
                    const index = formResponses.findIndex((x) => x.key === component.key);
                    component.value = value;
                    index != -1 ? formResponses[index] = component : formResponses.push(component);
                    form.setFieldsValue({ [component.key]: value });
                });
            }
            setMinClass("min");
        } else {
            deleteCard(false);
        }
    }


    const configModal = (message, btnOk, title) => {
        Modal.confirm({
            icon: '',
            title: title,
            className: 'modal-confirm',
            closable: false,
            okButtonProps: {
                className: 'ant-btn-solid c-2 ant-btn-size-xs margin-s'
            },
            cancelButtonProps: {
                className: 'ant-btn-solid c-2 ant-btn-size-xs margin-s'
            },
            okText: btnOk,
            content: <p>{message}</p>,
            onOk() { deleteCard(false) },
            cancelText: 'Cancelar',
        });
    }

    const getDescriptions = (name) => {
        const description = info.components.find((field) => field && field.label === name)
        return description && description.html
    }


    return (
        <div className='beneficiary-container'>
            {!showCard && <div className='beneficiary-container__btn'>
                <Button
                    className='ant-btn-outline c-2 ant-btn-size-xxs'
                    onClick={onClick}
                >
                    {
                        info && info.title ? info.title : ''

                    }
                </Button>
            </div>}
            {showCard && <div className={`beneficiary-container__item ${minClass}`}>
                <div className='beneficiary-container__item-header'>
                    {/* TODO: Detectar cuando sea Beneficiario Preferente: CardImg
                    y cuando sea DatosFacturacion: CardImgFact */}
                    <img src={info && info.properties &&
                        info.properties.img ? info.properties.img : CardImgFact} alt={info?.title} className='beneficiary-container__item-header__img' />
                    <div className='beneficiary-container__item-header__text'>
                        <div className='beneficiary-container__item-header__text-title'>
                            {info && info.title}
                        </div>
                        <div className='beneficiary-container__item-header__text-description'>
                            <div className='beneficiary-container__item-header__text-description-text'>
                                {info && info.components.map((field) =>
                                    field && field.label !== "informacion" && field.label !== "Descripcion" && <strong>{field.label}</strong>
                                )
                                }
                            </div>
                            <div className='beneficiary-container__item-header__text-description-actions'>
                                <em className="fal fa-pencil-alt" onClick={editClass} />
                                <div onClick={() => (deleteCard(true))} >
                                    <img src={EliminarImg} alt='Imagen icono eliminar' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='beneficiary-container__item-body'>
                    <div className='beneficiary-container__item-body-text'>
                        <td dangerouslySetInnerHTML={{ __html: getDescriptions('Descripcion') }} />
                    </div>
                    <div className='beneficiary-container__item-body-form'>
                        <Form.Item
                            name={info && info.key}
                        >
                            {info && info.components.map((field) =>
                                field && field.type === 'textfield' && <TextField info={field} form={form} key={field && field.key} current={current} />
                                || field.type === 'select' && <SelectField info={field} form={form} key={key} current={current} />
                            )}
                        </Form.Item>
                    </div>
                    <div className='beneficiary-container__item-body-text'>
                        <td dangerouslySetInnerHTML={{ __html: getDescriptions('informacion') }} />
                    </div>
                    <div className='beneficiary-container__item-body-actions'>
                        <Button
                            className='ant-btn-text c-2 ant-btn-size-xs'
                            onClick={() => (cancelCard())}
                        >
                            <strong>Cancelar</strong>
                        </Button>
                        <Button
                            className='ant-btn-outline c-2 ant-btn-size-xs'
                            onClick={saveClass}
                        >
                            <strong>Guardar</strong>
                        </Button>
                    </div>
                </div>
            </div>}
        </div>
    )
}